import Icon from '../components/Icon.vue'

Icon.register({
  hands: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M204.8 230.4C194.2 216.3 174.1 213.4 160 224 145.9 234.6 143 254.7 153.6 268.8L191.7 319.6C196.5 326 195.8 334.9 190.2 340.5L177.4 353.3C170.7 360 159.8 359.5 153.8 352.2L64 244.4V96C64 78.3 49.7 64 32 64S0 78.3 0 96V314.4C0 325.3 3.7 335.9 10.5 344.4L114.6 478.7C119.6 485.2 123 492.6 125 500.4 126.8 507.3 133.1 512 140.3 512H272C280.8 512 288 504.8 288 496V384C288 356.3 279 329.4 262.4 307.2L204.8 230.4zM608 64C590.3 64 576 78.3 576 96V244.4L486.2 352.2C480.2 359.4 469.2 359.9 462.6 353.3L449.8 340.5C444.2 334.9 443.5 326 448.3 319.6L486.4 268.8C497 254.7 494.1 234.6 480 224 465.9 213.4 445.8 216.3 435.2 230.4L377.6 307.2C361 329.4 352 356.3 352 384V496C352 504.8 359.2 512 368 512H499.7C506.8 512 513.2 507.3 515 500.4 517 492.6 520.4 485.2 525.4 478.7L629.5 344.4C636.3 335.9 640 325.3 640 314.4V96C640 78.3 625.7 64 608 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hands.js
// module id = mWxp
// module chunks = 144